import { P } from "components/BodyText/BodyText"
import { Button } from "components/Button/Button"
import { useNewReleaseAvailable } from "hooks/useNewReleaseAvailable"
import { useEffect } from "react"
import { toast } from "react-toastify"

/** One toast at most, however many releases are deployed while the tab is open */
export const NEW_RELEASE_TOAST_ID = "new-release"

const NewReleaseToast = () => (
  <div className="flex flex-col items-start gap-2">
    <P t="newRelease.message" color="inherit" />
    <Button
      t="newRelease.refresh"
      type="button"
      variant="unstyled"
      className="font-bold"
      onClick={() => window.location.reload()}
    />
  </div>
)

/**
 * Tells the user a new release was deployed and offers to refresh the page, in a toast that stays
 * until the page is refreshed.
 *
 * Never reloads by itself: the user may be halfway through a form, such as a questionnaire, a
 * registration or an e-consult, so they decide when to refresh.
 */
export const NewReleaseNotification = () => {
  const deployedRelease = useNewReleaseAvailable()

  useEffect(() => {
    if (!deployedRelease || toast.isActive(NEW_RELEASE_TOAST_ID)) {
      return
    }

    toast.info(<NewReleaseToast />, {
      toastId: NEW_RELEASE_TOAST_ID,
      autoClose: false,
      closeOnClick: false,
      closeButton: false,
      draggable: false,
      hideProgressBar: true,
      position: "top-center",
    })
  }, [deployedRelease])

  return null
}
